import { Link } from "react-router-dom";

export interface CategoryItem {
  slug: string;
  name: string;
  enName: string;
  icon: string;
  count: number;
  description: string;
  image: string;
}

interface CategoryCardProps {
  category: CategoryItem;
}

function CategoryCard({ category }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${category.slug}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative h-40 w-full overflow-hidden bg-background-200">
        <img
          src={category.image}
          alt={`${category.name}分类 - 爆料平台线索归档配图`}
          title={`${category.name} - 爆料平台主题分类`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent" />
        <div className="absolute bottom-3 left-4 right-4 flex items-end justify-between gap-2">
          <h3 className="font-heading text-lg font-bold text-background-50">{category.name}</h3>
          <span className="whitespace-nowrap rounded-full bg-background-50/90 px-2 py-0.5 text-[11px] font-label font-medium text-foreground-800">
            {category.count} 条
          </span>
        </div>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <span className="mb-2 flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
          <i className={`${category.icon} text-lg`} />
        </span>
        <p className="text-sm leading-relaxed text-foreground-600">{category.description}</p>
        <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-label font-medium text-primary-600">
          查看该分类
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
}

export default CategoryCard;